import * as React from "react";
import "../filters.scss";
import FilterButtons from "../FilterButtons";
import Input from "../../../../hiberUiKit/src/atoms/Input/Input";
import Checkbox from "../../../../hiberUiKit/src/atoms/Checkbox/Checkbox";


export interface SaveFiltersConfig {
	/**
	 * Filters view name
	 */
	name: string
	/**
	 * Add to favorite indicator
	 */
	addToFavorite: boolean
	/**
	 * Save only for me indicator
	 */
	saveOnlyForMe: boolean
}

interface IProps {
	/**
	 * On cancel
	 */
	onCancel: () => any
	/**
	 * On done click
	 */
	onDone: (data: SaveFiltersConfig) => any
}

export default class SaveFiltersButtonConfigView extends React.Component<IProps, SaveFiltersConfig> {

	constructor(props: IProps) {
		super(props);
		this.state = {name: "", addToFavorite: false, saveOnlyForMe: false}
	}

	render() {
		const { name, saveOnlyForMe, addToFavorite } = this.state;
		return (
			<div className={"c-save-filters-config"}>
				<div className={"c-save-filters-config-content"}>
					<Input type={"text"}
						   placeholder={"Name your view"}
						   value={name}
						   onChange={t => this.setState({name: t.target.value})}
						   focus/>
					<div className={"c-save-filters-config-checkbox-container"}>
						<Checkbox checked={addToFavorite}
									  label={"Add to favorite view"}
									  onChange={(v) => this.setState({addToFavorite:v})}/>
						<Checkbox checked={saveOnlyForMe}
									  label={"Save only for me"}
									  onChange={(v) => this.setState({saveOnlyForMe:v})}/>
					</div>
				</div>
				<div className={"c-save-filters-config-buttons"}>
					<FilterButtons onCancel={this.props.onCancel}
								   onDone={() => this.props.onDone({ name, saveOnlyForMe, addToFavorite})}
								   doneText={"Save"}
								   disabled={this.state.name.trim() === ""}/>
				</div>
			</div>
		);
	}

}
